import { GlobalState } from './types';

export const initialStateGlobal: GlobalState = {
    
}
